<div class="landing-home-stack mx-auto flex w-full flex-col items-center">
  <app-banner />
  <app-partners />
  <app-static-text />
  <app-explore-section />
  <app-faq-section />
</div>
<app-footer></app-footer>
